import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Auth.css";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaShieldAlt } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ content: "", type: "" });
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const navigate = useNavigate();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/employee/login-initiate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }
  
      setShowOtpForm(true);
      setOtpSent(true);
      startCountdown(120); // 2 minutes countdown
      setMessage({ content: data.message || "OTP sent to your email", type: "success" });
    } catch (error) {
      setMessage({ content: error.message, type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/employee/login-verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "OTP verification failed");
      }
  
      localStorage.setItem("employeeToken", data.token);
      setMessage({ content: "Login successful!", type: "success" });
      
      setTimeout(() => {
        navigate("/client");
      }, 1500);
    } catch (error) {
      setMessage({ content: error.message, type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/employee/resend-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Failed to resend OTP");
      }
  
      startCountdown(120); // Reset to 2 minutes
      setMessage({ content: "New OTP sent to your email", type: "success" });
    } catch (error) {
      setMessage({ content: error.message, type: "danger" });
    }
  };

  const startCountdown = (seconds) => {
    setOtpCountdown(seconds);
    const timer = setInterval(() => {
      setOtpCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setOtpSent(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div className="auth-container login-container">
      <div className="auth-card">
        <h2 className="text-center mb-4">Employee Login</h2>

        {message.content && (
          <div className={`alert alert-${message.type}`} role="alert">
            {message.content}
          </div>
        )}

        {!showOtpForm ? (
          <form onSubmit={handleLoginSubmit}>
            <div className="form-group mb-3 position-relative">
              <FaUser className="input-icon" />
              <input
                type="email"
                className="form-control auth-input"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group mb-3 position-relative">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                className="form-control auth-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="forgot-password text-end mb-3">
              <a href="/forgetpassword">Forgot Password?</a>
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Sending OTP..." : "Login"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleOtpSubmit}>
            <div className="form-group mb-3 position-relative">
              <FaShieldAlt className="input-icon" />
              <input
                type="text"
                className="form-control auth-input"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-3" disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
            {otpCountdown > 0 ? (
              <p className="text-center text-muted">
                Resend OTP available in {formatTime(otpCountdown)}
              </p>
            ) : (
              <button 
                type="button" 
                className="btn btn-link w-100"
                onClick={resendOtp}
              >
                Resend OTP
              </button>
            )}
          </form>
        )}

        <div className="text-center mt-3">
          Don't have an account? <a href="/signup" className="auth-link">Sign Up</a>
        </div>
      </div>
    </div>
  );
};
export default Login;